/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */

/*
Other data visualisation block
*/
import * as Blockly from 'blockly/core';
import 'blockly/python';
import { getAllowedOutputs } from '../block_compatibility_checks';

Blockly.Blocks['output_other_vis'] = {
    init: function () {
        let layerNameValidator = newValue => {
            let maxLength = 20;
            let cleanValue = newValue.replace(/[^a-zA-Z0-9 ]/g, "");
            let trimmedValue = cleanValue.substring(0, maxLength)
            return trimmedValue;
        }

        // serializable label means that when the toolbox grabs the XML to create the block
        // it fills in the label field with the label defined in the toolbox
        this.appendDummyInput()
            .appendField(new Blockly.FieldLabelSerializable("Other data visualisation. "), "otherVisLabel")
        this.appendDummyInput()
            .appendField("Layer name: ")
            .appendField(new Blockly.FieldTextInput("default", layerNameValidator), "layerName");

        this.getField("layerName").setTooltip(Blockly.Msg.LAYER_NAME_TOOLTIP)
        this.setPreviousStatement(true, 'other_vis');
        this.setNextStatement(true, getAllowedOutputs('other_vis'));
        this.setStyle('mapVisualisation');
        this.setTooltip(Blockly.Msg.OTHER_DATA_VIS_BLOCK_TOOLTIP);
        this.setHelpUrl("");
    }
};